import * as React from 'react';
import withClickOutsideOnOverlay from '../../../../../hoc/withClickOutsideOnOverlay';
import BasicFormWithValidation from '../../../../forms/BasicFormWithValidation';
import {FormWithCancelButton} from '../../../../forms/FormWithCancelButton';
import isValidEmail from '../../../../../services/mini/isValidEmail';

type AddOrganizationMemberFormProps = {
    userEmail: string;
    addMember: (email) => void;
}

class AddOrganizationMemberForm extends FormWithCancelButton<AddOrganizationMemberFormProps> {

    validateEmail = ({ email }) => {
        if (!email) {
            return 'Email should be filled';
        }
        if (!isValidEmail(email)) {
            return 'Invalid email';
        }
        if (email.toLowerCase() === this.props.userEmail) {
            return 'You are the owner of this organization';
        }
        return null;
    }

    ok = ({ email }) => {
        const { onClose, addMember } = this.props;
        onClose();
        addMember(email);
    }

    cancel = () => {
        const { onClose } = this.props;
        onClose();
    }

    render() {
        return <BasicFormWithValidation
            title="Invite New Member"
            type="add"
            hasCloseIcon={true}
            inputs={[{
                name: 'email',
                label: 'Member Email',
                autoComplete: "off",
                autoFocus: true,
                maxLength: 50,
                maxLengthMsg: `Max email length: 50 characters`,
                value: '',
                rules: [this.validateEmail],
                applyOnEnter: true
            }]}
            okButton={{
                label: 'Invite',
                action: this.ok
            }}
            cancelButton={{
                label: 'Cancel',
                action: this.cancel,
            }}
        />;
    }
}

export default withClickOutsideOnOverlay(AddOrganizationMemberForm);